import Vue from 'vue'
import App from './App.vue'
import router from "./router/routes"


Vue.config.productionTip = false

import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);

// import chillValue from './components/chillValue'
// Vue.component('chillValue', chillValue)

import chillNavbar from './components/chillNavbar'
Vue.component('chillNavbar', chillNavbar)
import pdfPrintNavbar from './components/pdfPrintNavbar'
Vue.component('pdfPrintNavbar', pdfPrintNavbar)

import imageInput from './components/imageInput'
Vue.component('imageInput', imageInput)

import listType from './components/listType'
Vue.component('listType', listType)

import modal from './components/modal/modal'
Vue.component('modal', modal)
import confirmModal from './components/modal/confirmModal'
Vue.component('confirmModal', confirmModal)
import shareModal from './components/modal/shareModal'
Vue.component('shareModal', shareModal)
import warningModal from './components/modal/warningModal'
Vue.component('warningModal', warningModal)
import chillIcon from './components/chillIcon'
Vue.component('chillIcon', chillIcon)
import chillFilter from './components/chillFilter'
Vue.component('chillFilter', chillFilter)
import chillBelt from './components/chillBelt'
Vue.component('chillBelt', chillBelt)
import infoBox from './components/infoBox'
Vue.component('infoBox', infoBox)
import loadingDots from './components/loadingDots'
Vue.component('loadingDots', loadingDots)
import loadingDotsDark from './components/loadingDotsDark'
Vue.component('loadingDotsDark', loadingDotsDark)

// PDF
import pdfVisit from './components/pdf/pdf_visit'
Vue.component('pdfVisit', pdfVisit)
import pdfChecklist from './components/pdf/pdf_checklist'
Vue.component('pdfChecklist', pdfChecklist)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

import Datepicker from 'vuejs-datepicker'
Vue.component('Datepicker', Datepicker)
        // components: {
        //     Datepicker
        // },




//------------------------------------------------------------------------------

import {auth} from "@/mixins/auth"
Vue.mixin(auth)
import {market} from "@/mixins/market"
Vue.mixin(market)
import {visit} from "@/mixins/visit"
Vue.mixin(visit)
import {checklist} from "@/mixins/checklist"
Vue.mixin(checklist)
import {translation} from "@/mixins/translation"
Vue.mixin(translation)
//------------------------------------------------------------------------------




Vue.prototype.$translation_sheet = false

import firebase from 'firebase/app';
const firebaseConfig = {
    apiKey: "AIzaSyBJyqMgP0_bBT2zQ4iaMT2YzAlX_3KrxQo",
    authDomain: "chillchecklist.firebaseapp.com",
    projectId: "chillchecklist",
    storageBucket: "chillchecklist.appspot.com",
    messagingSenderId: "633668209613",
    appId: "1:633668209613:web:17b02f7498f263015bd284"
  };

firebase.initializeApp(firebaseConfig);
// export const storage = firebase.storage()
export const fb = firebase;


import translation_file_de from "./assets/de.json";
export const translation_file = translation_file_de

import './registerServiceWorker'

// firebase.firestore().collection("translation").doc("de").get().then(snap => {
//     console.log("trans read")
// 	Vue.prototype.$translation_sheet = snap.data()
// });

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
